import styled from 'styled-components';
import { CreatableSelect } from 'components/atoms/select';
import { Label01, ProductiveHeading05 } from 'components/styles';

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ModalTitle = styled.div`
  ${ProductiveHeading05};
  padding: var(--spacing-05) 0;
`;

export const EmailSelect = styled(CreatableSelect)`
  margin-bottom: var(--spacing-09);
`;

export const Label = styled.div`
  ${Label01};
  color: var(--gray-80);
  margin-bottom: var(--spacing-03);
`;
